<form class="f-col blank-form" [formGroup]="employeeGradeForm">
    <div class="section-heading">
        <h2 class="h2-heading">{{content?.['b2b.managecompany.tpemployeegrade']}}<div class="dot">.</div> <span class="optional">{{content?.['b2b.managecompany.optional']}}</span></h2>
        <a role="button" class="link"
            *ngIf="commonObjPipes.GetAllDetails.pipe.length>0 && !Addnew" (click)="addNewEmployeeGrade()"><mat-icon fontSet="material-symbols-outlined"
                class="edit-icon">add</mat-icon> {{content?.['b2b.managecompany.addnew']}}</a>
    </div>

    <!-- <app-cam-empty-state></app-cam-empty-state> -->

    <div class="section-content" *ngIf="Addnew">
        <div class="inner-contentsection">
            <div class="f-row two--ColLayout">
                <div class="f-col">
                    <mat-form-field>
                        <mat-label>{{content?.['b2b.managecompany.categoryname']}}</mat-label>
                        <input matInput formControlName="employeeGradeName" (keypress)="blockInvalidCharacters1($event)"
                            (paste)="onPasteBlocked($event)" (contextmenu)="disableRightClick($event)">

                        <mat-error *ngIf="employeeGradeForm.get('employeeGradeName')?.hasError('required')">{{dictionaryContent?.['b2b.managecompany.categorynamereq']}}</mat-error>
                        <mat-error *ngIf="employeeGradeForm.get('employeeGradeName')?.hasError('maxlength')">{{dictionaryContent?.['b2b.managecompany.categorynamemaxlimit']}}</mat-error>
                        <mat-error *ngIf="employeeGradeForm.get('employeeGradeName')?.hasError('minlength')">{{dictionaryContent?.['b2b.managecompany.categorynameminlimit']}}</mat-error>
                    </mat-form-field>
                </div>
                <div class="f-col">
                    <mat-form-field>
                        <mat-label>{{content?.['b2b.managecompany.tpcategorycode']}}</mat-label>
                        <input matInput formControlName="employeeGradeCode" (keypress)="blockInvalidCharacters1($event)"
                            (paste)="onPasteBlocked($event)" (contextmenu)="disableRightClick($event)">

                        <mat-error *ngIf="employeeGradeForm.get('employeeGradeCode')?.hasError('required')">{{dictionaryContent?.['b2b.managecompany.categorycodereq']}}</mat-error>
                        <mat-error *ngIf="employeeGradeForm.get('employeeGradeCode')?.hasError('maxlength')">{{dictionaryContent?.['b2b.managecompany.categorycode30char']}}</mat-error>
                    </mat-form-field>
                </div>
            </div>

            <!-- <div class="f-row">
                <div class="f-col">
                    <div class="f-row validation-col">
                        <label class="mat-label">{{content?.['b2b.managecompany.tpbookfor']}}</label>
                        <div class="f-row mat-check-group">
                            <mat-checkbox class="checkbox-wrapper" formControlName="isBookForFamily"
                                (change)="onCheckboxBookFor('isBookForFamily', $event.checked)">{{content?.['b2b.managecompany.tpfamily']}}</mat-checkbox>
                            <mat-checkbox class="checkbox-wrapper" formControlName="isPersonal"
                                (change)="onCheckboxBookFor('isPersonal', $event.checked)">{{content?.['b2b.managecompany.tppersonal']}}</mat-checkbox>
                        </div>
                    </div>
                </div>
            </div> -->

            <!-- <div class="f-row">
                <div class="f-col">
                    <div class="f-row validation-col">
                        <label class="mat-label">Associate with Branch:</label>
                        <div class="f-row mat-check-group">
                            <mat-checkbox class="checkbox-wrapper"
                                *ngFor="let branch of commonObjPipes.GetAssociatedWithBranchId.pipe"
                                [checked]="associateWithBranchArray.includes(branch.ID.toString())"
                                (change)="onCheckboxChange($event, branch.ID)">{{branch.Name}}</mat-checkbox>
                        </div>
                    </div>
                </div>
            </div> -->

            <div class="f-row">
                <mat-form-field class="mat-chip-input custom-mat-dropdown-parent">
                    <mat-label>{{content?.['b2b.managecompany.associateoficelocation']}}</mat-label>
                    <mat-chip-grid #chipGrid aria-label="Fruit selection">
                        <mat-chip-row *ngFor="let name of branchName" (removed)="remove(name)">
                            {{name}}
                            <button matChipRemove [attr.aria-label]="'remove ' + name">
                                <mat-icon fontSet="material-symbols-outlined">close</mat-icon>
                            </button>
                        </mat-chip-row>
                    </mat-chip-grid>
                    <input [placeholder]="content?.['b2b.managecompany.select']" #fruitInput [formControl]="associatedWithBranch"
                        [matChipInputFor]="chipGrid" [matAutocomplete]="auto"
                        [matChipInputSeparatorKeyCodes]="separatorKeysCodes" (matChipInputTokenEnd)="add($event)"
                        (keypress)="blockInvalidCharacters1($event)" (paste)="onPasteBlocked($event)"
                        (contextmenu)="disableRightClick($event)" maxlength="50" />

                    <mat-icon fontSet="material-symbols-outlined" matSuffix class="mat-select">stat_minus_1</mat-icon>
                    <mat-autocomplete #auto="matAutocomplete" class="custom-autocomplete">
                        <mat-option *ngFor="let branch of filteredBranch | async" [value]="branch.corpBranchId">
                            <div (keydown.enter)="optionClicked(branch); $event.stopPropagation()" (keyup.space)="optionClicked(branch); $event.stopPropagation()" (click)="optionClicked(branch); $event.stopPropagation()">
                                <mat-checkbox class="checkbox-wrapper"
                                    (change)="onCheckboxChange($event, branch,'custom-mat-dropdown-parent','custom-autocomplete')"
                                    [checked]="selectedBranchIdsMap[branch.corpBranchId]"
                                    (click)="$event.stopPropagation()" (keyup.space)="$event.stopPropagation()"></mat-checkbox>
                                {{branch.corpBranchName}}
                            </div>
                        </mat-option>
                    </mat-autocomplete>
                </mat-form-field>
            </div>
            <mat-error *ngIf="associatedWithBranch.touched && noRecordFound">{{dictionaryContent?.['b2b.managecompany.validbranch']}} </mat-error>

            <div class="f-row">
                <div class="f-col">
                    <div class="f-row validation-col">
                        <label class="mat-label" for="">{{content?.['b2b.managecompany.status']}}</label>
                        <mat-radio-group aria-label="Select an option" formControlName="status">
                            <mat-radio-button [value]=true selected>{{content?.['b2b.managecompany.active']}}</mat-radio-button>
                            <mat-radio-button [value]=false>{{content?.['b2b.managecompany.inactive']}}</mat-radio-button>
                        </mat-radio-group>
                    </div>
                </div>
            </div>
        </div>

        <div class="inner-action">
            <button mat-button class="button--secondary-small" (click)="onCancel()">{{content?.['b2b.managecompany.cancel']}}</button>
            <button mat-button class="button--primary-small" (click)="onSave()"
                [class.disabled]="employeeGradeForm.invalid">{{content?.['b2b.managecompany.save']}}</button>
        </div>
    </div>

    <div class="section-table data-listing" *ngIf="commonObjPipes.GetAllDetails.pipe.length>0 && !Addnew">
        <table mat-table [dataSource]="commonObjPipes.GetAllDetails.pipe" class="mat-elevation-z0">
            <!-- Position Column -->
            <ng-container matColumnDef="Category Name">
                <th mat-header-cell *matHeaderCellDef> {{content?.['b2b.managecompany.categoryname']}} </th>
                <td mat-cell *matCellDef="let element"> {{element.categoryName}} </td>
            </ng-container>

            <!-- Name Column -->
            <ng-container matColumnDef="Category Code">
                <th mat-header-cell *matHeaderCellDef> {{content?.['b2b.managecompany.tpcategorycode']}} </th>
                <td mat-cell *matCellDef="let element"> {{element.categoryCode}} </td>
            </ng-container>

            <!-- Weight Column -->
            <ng-container matColumnDef="Status">
                <th mat-header-cell *matHeaderCellDef> {{content?.['b2b.managecompany.ddstatus']}}  </th>
                <td mat-cell *matCellDef="let element" class="status-tag">
                    <span [ngClass]="element.status ? 'status-active' : 'status-inactive'">
                        {{ element.status ? content?.['b2b.managecompany.active'] : content?.['b2b.managecompany.inactive'] }}
                    </span>
                </td>
            </ng-container>

            <!-- Symbol Column -->
            <ng-container matColumnDef="Actions">
                <th mat-header-cell *matHeaderCellDef> {{content?.['b2b.managecompany.ddactions']}} </th>
                <td mat-cell *matCellDef="let element" class="onclick-links">
                    <!-- <a class="onclick-cell primary-link" (click)="onEdit(element)">Edit</a>
                    <a class="onclick-cell warm-link" (click)="onRemove(element)">Remove</a> -->
                    <a tabindex="0" role="button" aria-label="Edit item" class="onclick-cell primary-link" (keydown.enter)="onEdit(element)" (click)="onEdit(element)"><mat-icon fontSet="material-symbols-outlined">Edit</mat-icon></a>
                    <a tabindex="0" role="button" aria-label="Remove item" class="onclick-cell warm-link" (keydown.enter)="onRemove(element)" (click)="onRemove(element)"><mat-icon fontSet="material-symbols-outlined">Delete</mat-icon></a>
                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
    </div>

    <ng-container *ngIf="!isLoading && commonObjPipes.GetAllDetails.pipe.length==0 && !Addnew">
        <app-cam-empty-state (myEvent)="handleEvent($event)" [heading]="content?.['b2b.managecompany.tpnoemploygradetitle']"
            [content]="content?.['b2b.managecompany.tpnoemploygradedesc']"
            [navigateTo]="'/cam/company-management/employeegrade'">
        </app-cam-empty-state>
    </ng-container>
</form>

<ng-template #selectionWarning>
    <div class="custom-dialog">
        <div class="d-justify-bw">
            <div class="custom-dialog__left">
                <div class="mat-dialog-title custom-dialog__title d-justify-bw">
                    <h2 class="mat-dialog-title"> {{content?.warningList[0]?.title}}</h2>
                    <!-- <div class="custom-overlay-close">
                        <mat-icon fontSet="material-symbols-outlined" class="close_icon" (click)="CloseDialog(false)">close</mat-icon>
                    </div> -->
                </div>
                <mat-dialog-content class="custom-dialog__text">
                    <div class="custom-dialog__description"> {{content?.warningList[0]?.description}}</div>
                </mat-dialog-content>
                <mat-dialog-actions>
                    <div class="dialog-actions-right">
                        <button class="button--secondary-small" mat-button (click)="CloseDialog(false)">{{content?.warningList[0]?.cancelCTAText}}</button>
                        <button class="button--primary-small" mat-button (click)="CloseDialog(true)">{{content?.warningList[0]?.confirmCTAText}}</button>
                    </div>
                </mat-dialog-actions>
            </div>
        </div>
    </div>
</ng-template>